module.exports = __webpack_public_path__ + "public/1.0.1_200686/img/18.147f7e5b.png";